import React from 'react';
import AllWorkspaces from '../workspace/AllWorkspaces';

const WorkspacesPage = () => <AllWorkspaces />;

export default WorkspacesPage;
